import Settings from './SettingWallet';
import {DieselRoute} from 'epic-diesel-common/src/hocs';

DieselRoute(Settings, {path: 'settings'});
